export default {"src":"/_next/static/media/circle-ci.e72c519f.svg","height":36,"width":129};